import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette } = lightTheme;
const styles: Record<string, SxProps> = {
  status: {
    borderRadius: '0.25rem',
    textTransform: 'none',
    height: '1.5rem',
    lineHeight: '1rem',
    '.MuiChip-label': {
      padding: '0.25rem',
      fontSize: '0.75rem',
      fontWeight: 900
    }
  },
  common: {
    backgroundColor: palette.grey['50'],
    textTransform: 'none'
  },
  positive: {
    backgroundColor: palette.primary['100'],
    border: `0.0625rem solid ${palette.primary['200']}`,
    color: palette.primary.main
  },
  negative: {
    backgroundColor: palette.mustardYellow['50'],
    border: `0.0625rem solid ${palette.mustardYellow.main}`,
    color: palette.grey.main
  },
  error: {
    backgroundColor: palette.lightishPink.main,
    border: `0.0625rem solid ${palette.brightRed.main}`,
    color: palette.brightRed.main
  },
  exchanged: {
    backgroundColor: palette.brightBlue['50'],
    border: `0.0625rem solid ${palette.brightBlue.main}`,
    color: palette.brightBlue.main
  },
  property: {
    backgroundColor: palette.grey['500'],
    color: palette.grey['50'],
    height: '1.5rem',
    '.MuiChip-label': {
      paddingY: '0.5rem',
      paddingX: '0.5rem',
      fontSize: '0.75rem'
    }
  },
  recommended: {
    backgroundColor: palette.lightishBlue.main
  },
  zeroDeposit: {
    backgroundColor: palette.mustardYellow.main
  },
  reduced: {
    backgroundColor: palette.darkishBlue.main
  },
  lastViewed: {
    backgroundColor: palette.vineGreen.main
  },
  recentlySold: {
    backgroundColor: palette.torchRed.main
  },
  recentlyLet: {
    backgroundColor: palette.torchRed.main
  },
  recentlyAdded: {
    backgroundColor: 'purple'
  },
  red: {
    backgroundColor: palette.bloodRed.main
  },
  green: {
    backgroundColor: palette.vineGreen[100]
  },
  text: {
    backgroundColor: palette.grey['50'],
    border: `0.0625rem solid ${palette.primary['200']}`,
    borderRadius: '0.25rem',
    '.MuiChip-label': {
      paddingY: '0.5625rem',
      paddingX: '0.5rem',
      fontSize: '0.875rem'
    },
    '.MuiChip-deleteIcon': {
      marginRight: '0.5rem',
      marginLeft: '0.25rem'
    },
    ':hover': {
      backgroundColor: undefined
    }
  },
  chipSelectable: {
    ':hover': {
      backgroundColor: palette.primary['400']
    }
  },
  chipSelected: {
    backgroundColor: palette.primary.light,
    color: palette.grey['50'],
    ':hover': {
      backgroundColor: {
        lg: palette.primary['300'],
        md: palette.primary['300'],
        xs: palette.primary.main
      }
    }
  },
  chipDeletable: {}
};

export default styles;
